<app-black-container>
  <div class="content">
    @if (!shouldShowSuccessMessage) {
    <h1 class="request-password__title">
      {{ 'REQUEST_PASSWORD.SET_PASSWORD' | translate }}
    </h1>
    <p class="request-password__paragraph">
      {{'REQUEST_PASSWORD.PARAGRAPH' | translate: {email: accountToUpdate.email
      || ''} }}
    </p>
    <app-md-error-handler [error]="error" [context]="'request-password'">
    </app-md-error-handler>
    <form (ngSubmit)="onSubmit(form)" #form="ngForm" appPasswordMatch>
      <c-input-text
        [label]="'LOGIN.PASSWORD' | translate"
        #passwordRef="ngModel"
        [(ngModel)]="credentials.password"
        autocomplete="new-password"
        name="password"
        inputID="password-input"
        [required]="true"
        passwordVisibility
        showText="{{'LOGIN.PASSWORD_VISIBILITY_OFF' | translate}}"
        hideText="{{'LOGIN.PASSWORD_VISIBILITY_ON' | translate}}"
      >
        @if (passwordRef?.errors?.required) {
        <p>{{ 'REQUEST_PASSWORD.REQUIRED_FIELD' | translate }}</p>
        }
        <c-password-strength-indicator
          content
          [control]="passwordRef.control"
          [passwordComplexity]="passwordComplexity"
        />
      </c-input-text>
      <div class="terms-of-service-container">
        <div class="checkbox__terms">
          <mat-checkbox
            name="terms"
            required
            [(ngModel)]="termsAccepted"
            #termsAcceptedRef="ngModel"
            [ngClass]="{
            invalid:
              termsAcceptedRef.errors?.required &&
              termsAcceptedRef.touched
          }"
            aria-labelledby="terms-description"
          >
          </mat-checkbox>
          <p id="terms-description">
            <span class="request-password__check_box_terms"
              >{{ 'GENERAL.AGREE' | translate }}</span
            >
            <a
              class="request-password__check_box_terms"
              href="https://www.cariloop.com/terms-of-service/"
              target="_blank"
              >{{ 'GENERAL.TOS' | translate }}</a
            >
            <span class="request-password__check_box_terms"
              >{{ 'GENERAL.AND' | translate }}</span
            >
            <a
              class="request-password__check_box_terms"
              href="https://www.cariloop.com/privacy-policy/"
              target="_blank"
              >{{ 'GENERAL.PRIVACY' | translate }}</a
            >
          </p>
        </div>
        <div role="alert">
          @if ( termsAcceptedRef.errors?.required && termsAcceptedRef.touched )
          {
          <span class="checkbox__error-text">
            {{ "GENERAL.TOS_ERROR" | translate }}
          </span>
          }
        </div>
      </div>
      <c-button
        type="submit"
        class="full-button"
        [text]="'REQUEST_PASSWORD.SET_PASSWORD' | translate"
        buttonStyle="fill"
        buttonType="neutral"
        size="large"
      ></c-button>
    </form>
    } @else {
    <app-success-container class="request-password__success-container">
      <h1
        #successHeader
        header
        tabindex="-1"
        class="request-password__success-title"
      >
        {{ "REQUEST_PASSWORD.PASSWORD_UPDATED" | translate }}
      </h1>
      <p body>{{ "REQUEST_PASSWORD.PASSWORD_UPDATED_MESSAGE" | translate }}</p>
    </app-success-container>
    <a
      routerLink="/login"
      class="request-password__back-to-login"
      c-button-style
      size="large"
      buttonType="neutral"
      buttonStyle="outline"
      >{{ "FORGOT_PASSWORD.BACK_TO_SIGN_IN" | translate }}</a
    >
    }
  </div>
</app-black-container>
